export default __webpack_public_path__ + "static/media/GLTitleImage.cc1853b5.webp";